import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Toast } from '../UI/toast/Toast';
import { fetchOnePeriod, fetchUpdatePeriod } from '../../helpers/api/finance';
import { confirmDuplicatePeriodDates } from '../../helpers/period/confirmDuplicatePeriodDates';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';
import PageHeader from '../common/PageHeader';
import { PreloadState } from '../UI/preloading/PreloadState';
import CreatePeriodForm from './CreatePeriodForm';

const EditPeriod = () => {
  const history = useHistory();
  const { id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (!id || isNaN(id)) return;
      setIsLoading(true);
      try {
        const response = await fetchOnePeriod(id, selectedCondominium);
        const periodData = response?.data || response;
        if (isMounted) setData(periodData);
      } catch (error) {
        handleErrorMessage(error);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [id, selectedCondominium]);

  if (!id || isNaN(id)) {
    history.goBack();
    return null;
  }

  const submitEdit = async (values) => {
    const condoId = data?.condominium_id || data?.condominiumId || selectedCondominium;
    const response = await fetchUpdatePeriod(id, condoId, values);
    if (response.code === SUCCESS_RESPONSE.OK || response.code === SUCCESS_RESPONSE.CREATED) {
      Toast.fire({ type: 'success', title: 'Se han guardado los cambios del período satisfactoriamente.' });
      history.goBack();
    }
  };

  const handleEdit = async (values) => {
    try {
      await submitEdit(values);
    } catch (error) {
      const handled = await confirmDuplicatePeriodDates(error, () =>
        submitEdit({ ...values, confirm_duplicate_dates: true }).catch(handleErrorMessage)
      );
      if (!handled) handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title={`Editar período - ${data?.name || ''}`}
        titleTag="h2"
        description="Modifica los datos del período o el porcentaje y fecha límite de pronto pago."
        className="mb-3"
      />
      <PreloadState loading={isLoading} message="Cargando información del período...">
        {data && (
          <CreatePeriodForm
            period={{
              id: data.id,
              name: data.name,
              startAt: data.start_at,
              endAt: data.end_at,
              discountPercentage: data.discount_percentage,
              discountDueDate: data.discount_due_date,
            }}
            handleSubmitData={handleEdit}
          />
        )}
      </PreloadState>
    </>
  );
};

export default EditPeriod;